import { TextField, MenuItem, ListSubheader } from '@mui/material';
import { Controller } from "react-hook-form";
import * as yup from "yup"; 

const SelectUF = ({
  field,
  useFormRef,
  schema,
  options,
  groupBy,
  getOptionLabel = (option) => option.label || option,
  label: labelProp,
  onValueChange,
  ...props
}) => {
  const { control } = useFormRef;

  let schemaLabel = "";
  try {
    const pathParts = field.split(/[\[\]\.]+/).filter(Boolean);
    const fieldSchema = pathParts.reduce((acc, key) => acc?.fields?.[key], schema);
    schemaLabel = fieldSchema?.spec?.label ?? "";
  } catch {
    schemaLabel = "";
  }

  const finalLabel = labelProp || schemaLabel;

  const renderItems = (options, groupBy) => {
    const result = [];
    const categorias = new Set();

    for (let opt of options) {
      const group = groupBy?.(opt);
      if (group && !categorias.has(group)) {
        categorias.add(group);
        result.push(<ListSubheader key={`group-${group}`}>{group}</ListSubheader>);
      }

      result.push(
        <MenuItem key={`option-${opt.sigla}`} value={opt.sigla}>
          {getOptionLabel(opt)}
        </MenuItem>
      );
    }

    return result;
  };

  return (
    <Controller
      name={field}
      control={control}
      render={({ field: { onChange, value, ref }, fieldState: { error } }) => {
        const validValue = options.some(opt => opt.sigla === value) ? value : "";

        return (
          <TextField
            label={finalLabel}
            error={!!error}
            helperText={error?.message}
            value={validValue}
            onChange={(e) => {
              const selected = options.find((opt) => opt.sigla === e.target.value);
              onChange(selected?.sigla ?? '');
              // Dispara só numa troca real feita pela pessoa - diferente de observar
              // o valor via watch(), que também reage a reset()/carregamento de dados.
              onValueChange?.(selected?.sigla ?? '');
            }}
            inputRef={ref}
            select
            fullWidth
            {...props}
          >
            {renderItems(options, groupBy)}
          </TextField>
        );
      }}
    />
  );
};

export default SelectUF;
